<template>
  <IhuModal
    id="exit-confirmation"
    :visible="isOpened"
    size="lg"
    @close="emitClose">
    <div class="save-exit-confirmation-modal-content">
      <div class="modal-title">
        Exit setup?
      </div>
      <div class="mt-2-rem">
        Are you sure you want to close the setup? At this stage, we are unable to save your input.
        Would you like to continue?
      </div>
      <div class="save-exit-confirmation-modal-footer mt-2-rem">
        <IhuButton variant="secondary"
                   :data-testid="`ihu-widget-exitmodal-cancel-button`"
                   @click="emitClose">
          Cancel
        </IhuButton>
        <IhuButton variant="primary"
                   class="ml-10px"
                   :data-testid="`ihu-widget-exitmodal-confirm-button`"
                   @click="emitConfirm">
          Confirm
        </IhuButton>
      </div>
    </div>
  </IhuModal>
</template>

<script>
  import { IhuModal, IhuButton } from '.';

  export default {
    name: 'ihu-close-modal',
    components: {
      IhuModal,
      IhuButton,
    },
    props: {
      isOpened: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    methods: {
      emitConfirm() {
        this.$emit('confirm');
      },
      emitClose() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss">
#exit-confirmation {
  text-align: left;
  font-size: 14px !important;
  line-height: 150%;
  padding-top: 10rem;

  .save-exit-confirmation-modal-content {
    padding: 2rem;
    font-weight: 400;
    font-size: 14px;
    line-height: 87%;
    .modal-title {
      font-weight: 500;
      font-size: 20.16px;
      line-height: 135%;
      letter-spacing: -0.01em;
      @include themify {
        color: getColor('widgetSaveConfirmationModalTitleColor', 'ihu') !important;
      }
    }
    .save-exit-confirmation-modal-footer {
      float: right;
      display: flex;
      padding-bottom: 2rem;
      .ml-10px {
        margin-left: 24px;
      }
    }
  }
}
</style>
